// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"110":"component---src-pages-datenschutz-js","538":"component---src-pages-impressum-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"110":"33524d6a247597313d16","538":"6e14fd9f6fb020f17ea4","678":"c9e563a4b0482511131e","883":"ecf11ce18a64db66c0de"}[chunkId] + ".js";
};